import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { TintingOptionsType } from 'data';
import {
	SwiperContainer,
	SwiperWrapper,
} from 'containers/catalogue/popular-categories/components/popular-categories-slider/styles';
import { Card } from '../card';
import { wrapperClassName } from '../buttons-list/styles';
import { cardListStyles, wrapperCardClassName } from './styles';

export type CardsListProps = {
	value: string;
	mobile?: boolean;
	tintingOptions: TintingOptionsType;
};
const CardListMobile = ({ value, mobile, tintingOptions }: CardsListProps) => (
	<SwiperWrapper>
		<Swiper
			data-qa="option-list-swiper"
			observeSlideChildren
			watchSlidesProgress
			className={`${SwiperContainer} ${wrapperClassName} ${wrapperCardClassName}`}
			slidesPerView="auto"
			style={{ marginTop: '0px' }}
		>
			{tintingOptions[value].map(option => (
				<SwiperSlide style={{ width: 'max-content' }} key={option.text}>
					<Card {...option} mobile={mobile} />
				</SwiperSlide>
			))}
		</Swiper>
	</SwiperWrapper>
);

const CardListNormal = ({ value, tintingOptions }: CardsListProps) => (
	<div className={cardListStyles}>
		<div className="card-list__gallery" data-qa="card-list__gallery">
			{tintingOptions[value].map(option => (
				<Card key={option.text} {...option} />
			))}
		</div>
	</div>
);
export const CardsList = ({ value, mobile, tintingOptions }: CardsListProps) => {
	return mobile ? (
		<CardListMobile value={value} mobile={mobile} tintingOptions={tintingOptions} />
	) : (
		<CardListNormal value={value} tintingOptions={tintingOptions} />
	);
};
